import { css } from '@emotion/core';
import styled from '@emotion/styled';
import React from 'react';
import { CancelIcon, type ITheme } from '../../../../../ui';
import MenuIcon from '../../../../../ui/assets/menu.svg';
import { MenuItem } from '../../../../../ui/new-components/MenuItem';
import Responsive from '../../../../../ui/utils/Responsive';
import { Logo } from '../../../components';
import { useTranslation } from '../../../i18n/translate/useTranslation';
import { Z_INDEX_MENU_OVERLAY } from '../../../styles';
import { AccountButton } from '../aside/account';
import { BREAKPOINT_SCROLLING_MENU } from '../constants';
import {
	NavItemType,
	useNavigationContext,
} from '../context/NavigationContext';
import { NavigationLogo } from '../NavigationLogo';

const NavigationLogoWrap = styled.div<{}>`
	flex-grow: 1;

	${Logo} {
		width: auto;
		height: 27px;
	}
`;
interface IStyledOverlayMenuToggleBarProps {
	isSticky: boolean;
	isMenuOpen: boolean;
}
const StyledOverlayMenuToggleBar = styled.div<
	IStyledOverlayMenuToggleBarProps,
	ITheme
>`
	width: 100%;
	display: none;
	position: ${({ isSticky }) => (isSticky ? 'fixed' : 'absolute')};
	${({ isSticky }) =>
		isSticky &&
		css`
			z-index: ${Z_INDEX_MENU_OVERLAY};
		`};
	background: #fff;

	@media (${BREAKPOINT_SCROLLING_MENU}) {
		align-items: center;
		padding: 24px 16px;
		border-bottom: 1px solid #efeff4;
		padding: 24px 16px;
	}
	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		display: flex;
		justify-content: space-between;
		top: ${({ isSticky, isMenuOpen }) =>
			isSticky || isMenuOpen ? '0' : 'unset'};
	}
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		top: ${({ isSticky, isMenuOpen }) =>
			isSticky || isMenuOpen ? '0' : 'unset'};
	}
`;

interface IOverlayMenuToggleBarProps {
	isFixed: boolean;
	isMenuOpen: boolean;
	onClickToggle: () => void;
}

export const OverlayMenuToggleBar = ({
	isFixed,
	isMenuOpen,
	onClickToggle,
}: IOverlayMenuToggleBarProps) => {
	const { t } = useTranslation();
	const { handleNavigationItemClick } = useNavigationContext();
	const handleToggleClick = () => {
		onClickToggle();
		handleNavigationItemClick({ type: NavItemType.Toggle, item: undefined }); // close all submenus
	};
	return (
		<StyledOverlayMenuToggleBar isSticky={isFixed} isMenuOpen={isMenuOpen}>
			<NavigationLogoWrap>
				<NavigationLogo />
			</NavigationLogoWrap>
			<StyledNavMobile>
				<AccountButton isMobileView />
				{isMenuOpen ? (
					<button
						aria-label={t('menu_toggle_button_close_label')}
						aria-controls="menu_nav_list"
						type="button"
						onClick={handleToggleClick}
					>
						<CancelIcon aria-hidden variation="highlight" />
					</button>
				) : (
					<MenuItem
						title={t('header_top_menu_label')}
						aria-controls="menu_nav_list"
						aria-expanded
						aria-label={t('menu_toggle_button_open_label')}
						icon={<MenuIcon aria-hidden />}
						onClick={handleToggleClick}
					/>
				)}
			</StyledNavMobile>
		</StyledOverlayMenuToggleBar>
	);
};

const StyledNavMobile = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;
